export const configs = {
    local: {
        url: "https://api-dev.nvidia.com/services/proxy",
        appName: "dev",
        refreshInterval: 15,
        clientKey: "5rU6hHI18mSj",
    },
    dev: {
        url: "https://api-dev.nvidia.com/services/proxy",
        appName: "dev",
        refreshInterval: 15,
        clientKey: "5rU6hHI18mSj",
    },
    stage: {
        url: "https://api-stage.nvidia.com/services/proxy",
        appName: "stage",
        refreshInterval: 15,
        clientKey: "dn59FBV0v07Y",
    },
    preview: {
        url: "https://api-stage.nvidia.com/services/proxy",
        appName: "stage",
        refreshInterval: 15,
        clientKey: "dn59FBV0v07Y",
    },
    prod: {
        url: "https://api-prod.nvidia.com/services/proxy",
        appName: "prod",
        refreshInterval: 45,
        clientKey: "53dM0M4efvbR",
    },
};
